import { Button, IconButton, Tooltip, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { DeleteIconButton, DownIcon, PrintIconButton } from "../../../assets/common-svg/CommonSvg";
import FormikControl from "../../../bmr/components/common/FormikControl";
import { FieldArray, FormikProvider } from "formik";
import { formatDayNumber } from './common'
import { notify } from "../../../bmr/utils/methods/notification";
import { useState } from "react";

const FormikArrayPreScreen = ({onReprint=null,showPrintButton=false,specialCaseAdd=false, props, formik, disabledAll, handleQuestionClick, queriesFields, buttonPermission, showDeleteButton=true }) => {
  // State to manage expanded accordions
  const [expandedAccordions, setExpandedAccordions] = useState({});

  const handleAccordionChange = (index) => (event, isExpanded) => {
    setExpandedAccordions(prev => ({
      ...prev,
      [index]: isExpanded
    }));
  };
  const parseFieldValue = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      try {
        return JSON.parse(value);
      } catch {
        return [];
      }
    }
    return [];
  };
 const printData = (index) =>{
  onReprint(index)
 }
  const handleAddChildren = (props) => {
    const fieldName = props?.fieldAppend;
    const prevValues = formik?.values?.[fieldName] || [];
    
    const fieldKey = Object.keys(props.initialChildrenData)[0];
    const rawValue = formik?.values?.[fieldKey];
    const newValue = formatDayNumber(rawValue);
    if(!rawValue){
      notify.error('Please enter a day valid day.');
      return;
    } 
    if (newValue < 1) {
      notify.error('Zero is not a valid day.');
      return;
    }
    if(newValue < 6){
      notify.error("The day must be greater than 6");
      return; 
    }
    const isDuplicate = prevValues.some(item => item[fieldKey] == newValue);
    if (isDuplicate) {
      notify.error("Day already exists");
      return;
    }
    const isLess = prevValues.some(item => newValue < item[fieldKey]);
    if (isLess) {
      notify.error("The day must not be earlier than the previously used day.");
      return;
    }

    const newChild = {
      ...props.initialChildrenData,
      [fieldKey]: newValue,
    };
    formik.setFieldValue(fieldName, [...prevValues, newChild]);
    formik.setFieldValue(fieldKey, "");
    
    // Auto-expand the newly added accordion
    const newIndex = prevValues.length;
    setExpandedAccordions(prev => ({
      ...prev,
      [newIndex]: true
    }));
  };

  // Function to get first child value for accordion summary
  const getFirstChildValue = (index) => {
    const fieldArrayValues = parseFieldValue(formik.values[props.name]);
    if (!fieldArrayValues || !fieldArrayValues[index]) return 'New Entry';
    
    const childData = fieldArrayValues[index];
    
    // Get the first meaningful value from the child object
    const firstFieldKey = Object.keys(childData)[0];
    const firstFieldValue = childData[firstFieldKey];
    
    if (firstFieldValue !== undefined && firstFieldValue !== null && firstFieldValue !== '') {
      // If it's a number, show as "Day X", otherwise show the value
      if (typeof firstFieldValue === 'number' || !isNaN(firstFieldValue)) {
        return `Day ${firstFieldValue}`;
      }
      return String(firstFieldValue);
    }
    
    return 'New Entry';
  };

  // Common function to render field with question icon
  const renderFieldWithQuestion = (subFieldProps, subFieldPropsIndex, questionInfo) => {
    return (
      <div key={subFieldPropsIndex} className="w-full relative">
        <FormikControl
          formik={formik}
          {...subFieldProps}
          disabled={questionInfo?.resolve == 0 ? false : subFieldProps.disabled}
        />
        {!subFieldProps.noQuery && disabledAll && <i
          onClick={(e) => handleQuestionClick(e, subFieldProps, questionInfo)}
          style={questionInfo?.resolve == 0 ? { color: "red" } : {}}
          className="fas fa-question-circle circle-icon cursor-pointer z-50 absolute top-[0.3rem] right-2"
          aria-hidden="true"
        />}
      </div>
    );
  };
//showPrintButton
  const printButtonDynamic = (index) => {
     return (
      <div className={"self-end md:self-center mt-3"}>
        <Tooltip title="Print">
          <span>
            <IconButton
              onClick={() => printData(index)}
            >
              <PrintIconButton
                bgColor={"#2F5597"}
              />
            </IconButton>
          </span>
        </Tooltip>
      </div>
    );
  } 
  // Common function to render delete button
  const renderDeleteButton = (index, remove, disabledAll) => {
    return (
      <div className={(disabledAll || formik.values[props.name].length == 1) ? "self-end md:self-center mt-3 disable-add-visit-btn" : "self-end md:self-center mt-3"}>
        <Tooltip title="Delete">
          <span>
            <IconButton
              onClick={() => { (disabledAll || formik.values[props.name].length == 1) ? "" : remove(index) }}
            >
              <DeleteIconButton
                bgColor={"#FA5151"}
              />
            </IconButton>
          </span>
        </Tooltip>
      </div>
    );
  };

  // Common function to render add button
  const renderAddButton = (push) => {
    if (specialCaseAdd || ((props.multipleField || props?.showAddBtn) && !disabledAll && buttonPermission)) {
      return (
        <div className={props?.flexItem ? 'mb-4 mr-2' :"text-end m-2"}>
          <Button
            type="button"
            disabled={specialCaseAdd ? !specialCaseAdd : disabledAll}
            onClick={() => props?.showAddBtn ? handleAddChildren(props) : push(props.initialChildrenData || {})}
            className="mt-4"
            fullWidth
          >
            Add
          </Button>
        </div>
      );
    }
    return null;
  };

    // Helper function to get container class
  const getContainerClass = (props, isAccordion = false) => {
    if (isAccordion) {
      return props?.shouldFlexDel ? 'mt-3 flex gap-x-4 w-full' : props.col && `flex-1 grid grid-cols-1 md:grid-cols-${props.col} gap-4 w-full`;
    }
    
    if (props?.flexItem) return `flex w-full m-2`;
    if (props.col) return `p-4 flex flex-col md:flex-row gap-4 items-start md:items-center`;
    return `flex-1 grid grid-cols-1 md:grid-cols-1 gap-4 w-full`;
  };

    // Helper function to get main container class
  const getMainContainerClass = (props) => {
    if (props?.flexItem) return `flex border rounded-lg shadow-sm bg-white`;
    if (!props.col) return `flex flex-col md:flex-row gap-4 items-start md:items-center`;
    if (props?.shouldFlexDel) return '';
    return `border rounded-lg shadow-sm bg-white m-2`;
  };
  
    // Function to check if current row has errors
  const hasRowErrors = (index) => {
    const errors = formik.errors[props.name];
    if (!errors) return false;
    
    // If errors is an array, check the specific index
    if (Array.isArray(errors)) {
      const rowError = errors[index];
      // If rowError exists and is not empty object/array
      return rowError && (typeof rowError === 'string' || (typeof rowError === 'object' && Object.keys(rowError).length > 0));
    }
    
    // If errors is an object with index keys
    if (typeof errors === 'object' && errors[index]) {
      return true;
    }
    
    return false;
  };
  // Render accordion view
  const renderAccordionView = (push, remove) => {
    return (
      <div className={getMainContainerClass(props)}>
        {parseFieldValue(formik.values[props.name])?.map((_, index) => (
          <Accordion
            key={index}
            expanded={expandedAccordions[index] || false}
            onChange={handleAccordionChange(index)}
            className="w-full !rounded-lg !shadow-sm !mb-2"
            sx={{
              border: `1px solid #C3C3C3`
            }}
          >
            <AccordionSummary
              expandIcon={
                <div className="d-flex gap-3 align-items-center">
                  <DownIcon />
                </div>
              }
              aria-controls={`panel-${props.name}-${index}-content`}
              id={`panel-${props.name}-${index}-header`}
            >
              <div className="font-bold text-[14px] flex items-center gap-2 w-full">
                  {getFirstChildValue(index)}
                  {index == 0 && hasRowErrors(index) && (
                    <span className="text-red-500 text-xs font-normal">
                      (Please fill the required fields)
                    </span>
                  )}
                </div>
            </AccordionSummary>
            
            <AccordionDetails>
              <div className={getContainerClass(props, true)} >
                 {props.children(index)
                .filter((_, subFieldPropsIndex) => subFieldPropsIndex !== 0) // Skip first child
                .map((subFieldProps, subFieldPropsIndex) => {
                  const questionInfo = queriesFields?.find(op => op.fields === subFieldProps.name);
                  const isLastField = subFieldPropsIndex === props.children(index).length - 2;
                  return (
            <>
              {renderFieldWithQuestion(subFieldProps, subFieldPropsIndex, questionInfo)}
              {(subFieldProps.multipleField || props?.shouldFlexDel) && isLastField && showDeleteButton  && (
                 renderDeleteButton(index, remove, disabledAll)
              )}
            </>
          );
              })}
              </div>
              {props.multipleField && showDeleteButton && renderDeleteButton(index, remove, disabledAll)}
             
            </AccordionDetails>
          </Accordion>
        ))}
        {renderAddButton(push)}
      </div>
    );
  };
  // Render normal view (without accordion)
  const renderNormalView = (push, remove) => {
    let disabledbtn=true; 
    return (
         <>
         {parseFieldValue(formik.values[props.name])?.map((_, index) => (
            <div 
        key={'_next'+ index} 
        className={getContainerClass(props, false)}
      >
            <div
              className={(props?.flexItem || props?.object) ? 'flex justify-between items-center w-full gap-2': props.col && `flex-1 grid grid-cols-1 md:grid-cols-${props.col} gap-4 w-full`}
            >
              {props?.children(index)?.map((subFieldProps, subFieldPropsIndex) => {
              if (subFieldProps?.type == 'label_item') {
                return <span className="whitespace-nowrap font-bold" key={subFieldPropsIndex}>{subFieldProps?.label}</span>;
              } else {
                disabledbtn=subFieldProps?.disabled
                const questionInfo = queriesFields?.find(op => op.fields === subFieldProps.name);
                return renderFieldWithQuestion(subFieldProps, subFieldPropsIndex, questionInfo);
              }
            })}
            </div>
            {props.multipleField && !disabledbtn && renderDeleteButton(index, remove, disabledbtn)}
            {showPrintButton && disabledbtn && printButtonDynamic(index)}
          </div>
        ))}
        {renderAddButton(push)}
      </>
    );
  };

  return (
    <FormikProvider value={formik}>
      <FieldArray name={props.name}>
        {({ push }) => {

      const handleRemove = (index) => {
    const arrayCopy = [...formik.values[props.name]];

    // Step 1: Remove row
    arrayCopy.splice(index, 1);

    // Step 2: Update one column after remove
    const updatedArray = arrayCopy.map((item, idx) => ({
      ...item,
  ...(Object.prototype.hasOwnProperty.call(item, "identifier") && { identifier: idx + 1 })
    }));

    // Step 3: Save back to Formik
    formik.setFieldValue(props.name, updatedArray);
  };
          return (<div className={getMainContainerClass(props)}>
          {props?.useAccordion ? renderAccordionView(push, handleRemove) : renderNormalView(push, handleRemove)}
          </div>)
        }}
      </FieldArray>
    </FormikProvider>
  );
}

export default FormikArrayPreScreen;